/**
 * @generated SignedSource<<25629de5cd6521c2c4d8ddbae307cfb6>>
 * @relayHash 9f3804059f817e66c9f5d118131a5d95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 278d1d02ca9988a436ecd2ed0f40ed9bd2d6714d11a8385dc7bb75edb65af03b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraJqlClauseType = "ANY" | "ORDER_BY" | "WHERE" | "%future added value";
export type JiraJqlOperator = "CHANGED" | "CONTAINS" | "EQUALS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUAL" | "IN" | "IS" | "IS_NOT" | "LESS_THAN" | "LESS_THAN_OR_EQUAL" | "NOT_CONTAINS" | "NOT_EQUALS" | "NOT_IN" | "WAS" | "WAS_IN" | "WAS_NOT" | "WAS_NOT_IN" | "%future added value";
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraJqlScopeInput = {
  board?: JiraJqlBoardInput | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type main_IssueTypeJqlBuilderBasicFieldsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  excludeFields?: ReadonlyArray<string> | null | undefined;
  first?: number | null | undefined;
  forClause?: JiraJqlClauseType | null | undefined;
  jqlContext?: string | null | undefined;
  scope?: JiraJqlScopeInput | null | undefined;
  searchString: string;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type main_IssueTypeJqlBuilderBasicFieldsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly fields: {
        readonly __typename: "JiraJqlFieldConnection";
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly description: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly jqlTerm: string;
            readonly operators: ReadonlyArray<JiraJqlOperator>;
            readonly searchTemplate: {
              readonly key: string | null | undefined;
            } | null | undefined;
            readonly shouldShowInContext: boolean | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number | null | undefined;
      } | {
        readonly __typename: "QueryError";
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined;
  };
};
export type main_IssueTypeJqlBuilderBasicFieldsQuery = {
  response: main_IssueTypeJqlBuilderBasicFieldsQuery$data;
  variables: main_IssueTypeJqlBuilderBasicFieldsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeFields"
},
v3 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forClause"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlContext"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v9 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "excludeFields",
    "variableName": "excludeFields"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "forClause",
    "variableName": "forClause"
  },
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jqlContext"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  },
  {
    "kind": "Variable",
    "name": "viewContext",
    "variableName": "viewContext"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v13 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v15 = {
  "concreteType": "JiraJqlFieldEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraJqlField",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jqlTerm"
        },
        (v14/*: any*/),
        {
          "concreteType": "JiraJqlSearchTemplate",
          "kind": "LinkedField",
          "name": "searchTemplate",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        {
          "kind": "ScalarField",
          "name": "operators"
        },
        {
          "concreteType": "JiraFieldType",
          "kind": "LinkedField",
          "name": "fieldType",
          "plural": false,
          "selections": [
            (v14/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "shouldShowInContext"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v9/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v10/*: any*/),
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v11/*: any*/),
                        (v12/*: any*/),
                        (v13/*: any*/),
                        (v15/*: any*/)
                      ],
                      "type": "JiraJqlFieldConnection"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v11/*: any*/)
                      ],
                      "type": "QueryError"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/)
                    ],
                    "type": "JiraJqlFieldConnection"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "278d1d02ca9988a436ecd2ed0f40ed9bd2d6714d11a8385dc7bb75edb65af03b",
    "metadata": {},
    "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "744e35745d428b3b4fc4514e1a4087bc";

export default node;
